<template>
  <div :class="{'unsubscribe': true, 'no-px2rem': !isMobile}">
    <header><img class="logo" :src="logoImg" alt=""></header>
    <section class="section">
      <h2 class="title">{{unsubscribeEmail}}</h2>
      <rich-radio-group
        class="radio-list"
        v-model="unsubscribeTime"
        :options="unsubscribeTimeOptions"
        position="right"
      />
      <h2 class="title">{{gettext('退订理由：')}}</h2>
      <!-- <rich-radio-group
        class="radio-list"
        v-model="unsubscribeReason"
        :options="unsubscribeReasonOptions"
        position="right"
        :hollow-style="true"
      /> -->
      <rich-checkbox-group
        class="radio-list"
        v-model="unsubscribeReason"
        :options="unsubscribeReasonOptions"
        position="right"
      />
      <div class="btns">
        <rich-button
          class="button"
          inline primary
          type="submit"
          @click="submitHandler"
          >
          {{gettext('确认')}}
        </rich-button>
      </div>
    </section>
  </div>
</template>
<script>
import didiaxios from '@didi/dajax/dist/dajax'
import imgDidi from '@/assets/images/logo.png'
import img99 from '@/assets/images/logo-99@3x.png'
import { getLocaleBrandText } from '@/common/js/utils'
import { sprintf } from '@didi/gettext'

export default {
  name: 'unsubscribeIndex',
  data () {
    return {
      isMobile: false,
      unsubscribeTime: '6',
      unsubscribeReason: [],
      unsubscribeTimeOptions: [
        {
          label: this.gettext('是，半年之内不要给我发邮件'),
          value: '6'
        },
        {
          label: this.gettext('是，一年之内不要给我发邮件'),
          value: '12'
        },
        {
          label: this.gettext('是，再也不要给我发邮件了'),
          value: '120000'
        }
      ]
    }
  },
  computed: {
    country () {
      return this.$store.state.country
    },
    logoImg () {
      let imgurl = ''

      if (this.country === 'BR') {
        imgurl = img99
      } else if (this.country === 'MX') {
        imgurl = imgDidi
      } else {
        imgurl = imgDidi
      }

      return imgurl
    },
    unsubscribeEmail () {
      return sprintf(this.gettext('如果您退订邮件，可能会错过重要消息，您确定不再接收%s给您发送的邮件吗？'), getLocaleBrandText('brand_txt_1'))
    },
    unsubscribeReasonOptions () {
      return [
        {
          label: this.gettext('邮件频率过高'),
          value: this.gettext('邮件频率过高')
        },
        {
          label: this.gettext('对此类邮件不感兴趣'),
          value: this.gettext('对此类邮件不感兴趣')
        },
        {
          label: sprintf(this.gettext('暂时不需要%s的服务'), getLocaleBrandText('brand_txt_1')),
          value: sprintf(this.gettext('暂时不需要%s的服务'), getLocaleBrandText('brand_txt_1'))
        }
      ]
    }
  },
  created () {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  methods: {
    async submitHandler () {
      let { t, c } = this.$route.query
      if (this.unsubscribeTime && this.unsubscribeReason) {
        let params = {
          ticket: t,
          code: c,
          from: 'didiGlobal',
          unsubscribeTime: this.unsubscribeTime,
          unsubscribeReason: this.unsubscribeReason
        }
        let res = await this.submitData(params)
        if (res.errno === 0) {
          this.$router.push({
            path: `/unsubscribe/result`
          })
        } else {
          let txt = res.errmsg || 'error'
          this.showToast(txt)
        }
      }
    },
    submitData (data) {
      return didiaxios.request({
        url: '/msgcenter-api/api/unsubscribe/email',
        method: 'POST',
        emulateJSON: true,
        needEncrypt: true,
        params: '',
        body: data
      }).then(res => res.data).catch((err) => console.log(err))
    },
    showToast (text) {
      const toast = this.$createToast({
        time: 2000,
        txt: text,
        type: 'error'
      })
      toast.show()
    }
  }
}
</script>
<style lang="stylus" scoped>
.unsubscribe {
  background-color white
  color #333;
  width 100%
  height 100%
  overflow-x hidden
  overflow-y auto
  header{
    padding 48px
    .logo{
      height 40px
    }
  }
  .section{

  }
  .title{
    font-size 32px
    font-weight bold
    line-height 50px
    padding 30px 48px
  }
  .radio-list{
    font-size 28px
    margin-bottom 30px
    ::v-deep .rich-radio{
      padding 0 48px
    }
    ::v-deep .rich-checkbox{
      padding 0 48px
    }
  }
  .border-top-1px:before{
    width 1300px
    margin-left 48px
  }
  .border-bottom-1px:after{
    width 1300px
    margin-left 48px
  }
  .btns{
    margin-top 77px
    text-align center
    padding-bottom 40px
    .button{
      font-size 32px
      height 74px
      width 294px
    }
  }
}
.unsubscribe.no-px2rem{
  font-size 12px
  header{
    width 100%
    padding 20px
    .logo{
      height 36px
    }
  }
  .section {
    font-size 24px
    width 578px
    margin 30px auto 0
    .title{
      font-size 24px
      font-weight bold
      line-height 36px
      padding 20px 42px
    }
    .radio-list{
      font-size 18px
      margin-bottom 30px
      ::v-deep .rich-radio{
        padding 0 48px
        .rich-radio-label{
          height 50px
          line-height 50px
        }
      }
      ::v-deep .rich-checkbox{
        padding 0 48px
        .rich-checkbox-label{
          height 50px
          line-height 50px
        }
      }
    }
    .border-top-1px:before{
      width 500px
      margin-left 42px
    }
    .border-bottom-1px:after{
      width 500px
      margin-left 42px
    }
    .btns{
      margin-top 60px
      padding-right 36px
      text-align right
      .button{
        font-size 18px
        height 46px
        width 116px
      }
    }
  }
}
</style>
